import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Portaltable() {
  return (
    <section className="portal_table p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              How Long Does <span>Vendor Portal</span> Development Take?
            </h2>
            <p>
              The time required to develop a vendor portal is determined by its
              level of complexity. Here's a summary of the predicted timelines:
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="portal-table-main">
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3>Level of Complexity</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3 className="light-black-head">Development Timeline</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3>Vendor Portal Prototype</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3 className="light-black-head">
                    Typically developed within 2–8 weeks.
                  </h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3>Basic Vendor Portal</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3 className="light-black-head">
                    Generally takes around 3–4 months to complete.
                  </h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3>Medium Complexity Vendor Portal</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3 className="light-black-head">
                    Usually requires 5–8 months for full development.
                  </h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3>Advanced Vendor Portal</h3>
                </div>
              </div>
              <div className="portal-table-item">
                <div className="portable-head">
                  <h3 className="light-black-head">
                    Often takes 9–12 months or more, though an initial version
                    can be launched in 3–4 months.
                  </h3>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <p>
              These deadlines, that cover design, development, testing, and
              deployment, are subject to change following particular
              specifications and the scope of the project.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Portaltable;
